/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Field limits for dangerous goods declarations.
 * @export
 * @interface ShipmentLimitsDangerousGoods
 */
export interface ShipmentLimitsDangerousGoods {
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxUnNumberLength: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxClassificationLength: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxPackingGroupLength: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxProperShippingNameLength: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxTechnicalNameLength: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxPackagingTypeLength: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxNumberPackages: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxTdgResponsibleNameLength: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsDangerousGoods
     */
    maxNetExplosiveQuantityKg: number;
    /**
     * Regular expression a Transport Canada ERAP plan number must match.
     * @type {string}
     * @memberof ShipmentLimitsDangerousGoods
     */
    erapPlanNumberPattern: string;
}

/**
 * Check if a given object implements the ShipmentLimitsDangerousGoods interface.
 */
export function instanceOfShipmentLimitsDangerousGoods(value: object): value is ShipmentLimitsDangerousGoods {
    if (!('maxUnNumberLength' in value) || value['maxUnNumberLength'] === undefined) return false;
    if (!('maxClassificationLength' in value) || value['maxClassificationLength'] === undefined) return false;
    if (!('maxPackingGroupLength' in value) || value['maxPackingGroupLength'] === undefined) return false;
    if (!('maxProperShippingNameLength' in value) || value['maxProperShippingNameLength'] === undefined) return false;
    if (!('maxTechnicalNameLength' in value) || value['maxTechnicalNameLength'] === undefined) return false;
    if (!('maxPackagingTypeLength' in value) || value['maxPackagingTypeLength'] === undefined) return false;
    if (!('maxNumberPackages' in value) || value['maxNumberPackages'] === undefined) return false;
    if (!('maxTdgResponsibleNameLength' in value) || value['maxTdgResponsibleNameLength'] === undefined) return false;
    if (!('maxNetExplosiveQuantityKg' in value) || value['maxNetExplosiveQuantityKg'] === undefined) return false;
    if (!('erapPlanNumberPattern' in value) || value['erapPlanNumberPattern'] === undefined) return false;
    return true;
}

export function ShipmentLimitsDangerousGoodsFromJSON(json: any): ShipmentLimitsDangerousGoods {
    return ShipmentLimitsDangerousGoodsFromJSONTyped(json, false);
}

export function ShipmentLimitsDangerousGoodsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsDangerousGoods {
    if (json == null) {
        return json;
    }
    return {
        
        'maxUnNumberLength': json['maxUnNumberLength'],
        'maxClassificationLength': json['maxClassificationLength'],
        'maxPackingGroupLength': json['maxPackingGroupLength'],
        'maxProperShippingNameLength': json['maxProperShippingNameLength'],
        'maxTechnicalNameLength': json['maxTechnicalNameLength'],
        'maxPackagingTypeLength': json['maxPackagingTypeLength'],
        'maxNumberPackages': json['maxNumberPackages'],
        'maxTdgResponsibleNameLength': json['maxTdgResponsibleNameLength'],
        'maxNetExplosiveQuantityKg': json['maxNetExplosiveQuantityKg'],
        'erapPlanNumberPattern': json['erapPlanNumberPattern'],
    };
}

  export function ShipmentLimitsDangerousGoodsToJSON(json: any): ShipmentLimitsDangerousGoods {
      return ShipmentLimitsDangerousGoodsToJSONTyped(json, false);
  }

  export function ShipmentLimitsDangerousGoodsToJSONTyped(value?: ShipmentLimitsDangerousGoods | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxUnNumberLength': value['maxUnNumberLength'],
        'maxClassificationLength': value['maxClassificationLength'],
        'maxPackingGroupLength': value['maxPackingGroupLength'],
        'maxProperShippingNameLength': value['maxProperShippingNameLength'],
        'maxTechnicalNameLength': value['maxTechnicalNameLength'],
        'maxPackagingTypeLength': value['maxPackagingTypeLength'],
        'maxNumberPackages': value['maxNumberPackages'],
        'maxTdgResponsibleNameLength': value['maxTdgResponsibleNameLength'],
        'maxNetExplosiveQuantityKg': value['maxNetExplosiveQuantityKg'],
        'erapPlanNumberPattern': value['erapPlanNumberPattern'],
    };
}

